export default [
  {
    path: "/workouts",
    name: "Workouts",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/Workouts.vue"),
    meta: { navbarTitle: "Deine Workouts" },
    children: [
      { path: "create", name: "WorkoutCreate", component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkoutCreate.vue") },
      {
        path: "createnew",
        name: "WorkoutCreateNew",
        component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkoutCreateNew.vue"),
        meta: { hideBottomNavigation: true },
      },
      { path: "edit/:id", name: "WorkoutEdit", component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkoutCreate.vue") },
    ],
  },
  {
    path: "/workouts/completed",
    name: "WorkoutCompleted",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkingoutCompleted.vue"),
  },
  {
    path: "/workouts/completed/pre",
    name: "WorkoutCompletedOld",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/WorkingoutCompletedOld.vue"),
  },
  {
    path: "/workouts/run/:id",
    name: "WorkoutRun",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/Workingout.vue"),
  },
  {
    path: "/plan/run/:id",
    name: "planRun",
    component: () => import(/* webpackChunkName: "workouts" */ "@/views/workouts/PlanRun.vue"),
  },
]
